import { FastSinglelist } from "../../../utils/SingletonList";
import { WebGLEngine } from "./WebGLEngine";
export class WebGLRenderGeometryElement {
    get indexFormat() {
        return this._indexFormat;
    }
    set indexFormat(value) {
        this._indexFormat = value;
        this._glindexFormat = WebGLEngine.instance.getDrawContext().getIndexType(this._indexFormat);
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
        this._glmode = WebGLEngine.instance.getDrawContext().getMeshTopology(this._mode);
    }
    constructor(mode, drawType) {
        this._id = ++WebGLRenderGeometryElement._idCounter;
        this.mode = mode;
        this.drawParams = new FastSinglelist();
        this.drawType = drawType;
    }
    getDrawDataParams(out) {
        out && this.drawParams.cloneTo(out);
    }
    setDrawArrayParams(first, count) {
        this.drawParams.add(first);
        this.drawParams.add(count);
    }
    setDrawElemenParams(count, offset) {
        this.drawParams.add(offset);
        this.drawParams.add(count);
    }
    destroy() {
        delete this.drawParams;
    }
    clearRenderParams() {
        this.drawParams.length = 0;
    }
    cloneTo(obj) {
        obj.mode = this.mode;
        obj.drawType = this.drawType;
        obj.indexFormat = this.indexFormat;
        obj.instanceCount = this.instanceCount;
        obj.drawParams.elements = this.drawParams.elements.slice();
        obj.drawParams.length = this.drawParams.length;
    }
}
WebGLRenderGeometryElement._idCounter = 0;
